
(()=>{'use strict';
const q=(s,r=document)=>r.querySelector(s),all=(s,r=document)=>[...r.querySelectorAll(s)];
const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches,finePointer=matchMedia('(hover:hover) and (pointer:fine)').matches;
const clamp=(v,a=0,b=1)=>Math.min(b,Math.max(a,v));
document.documentElement.classList.add('lx-js');

// ---- Reveal: tag headings/leads in retained sections, then observe everything once.
const auto=['.selection-studio h2','.seat-experience .experience-heading','.footprint .experience-heading','#spa-water-care .pbht-head','.spa-shop h2','#hot-tub-service .pbht-head','#hot-tub-faq .pbht-head','#hot-tub-contact .pbht-head','.cover-process h2','.builder-heading','.replace-cover h2','.cover-cross h2'];
all(auto.join(',')).forEach(el=>el.classList.add('lx-reveal'));
if(reduce||!('IntersectionObserver' in window))all('.lx-reveal').forEach(el=>el.classList.add('is-in'));
else{const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}}),{rootMargin:'0px 0px -12% 0px'});all('.lx-reveal').forEach(el=>io.observe(el));}

// ---- Scroll-linked work is batched into one rAF per scroll frame.
const tasks=[];let ticking=false;
const run=()=>{ticking=false;const vh=innerHeight;for(const t of tasks)t(vh);};
const schedule=()=>{if(!ticking){ticking=true;requestAnimationFrame(run);}};
addEventListener('scroll',schedule,{passive:true});addEventListener('resize',schedule);

// ---- Construction cutaway: scroll (or the index) walks through the spa's layers.
//      The drawing stays put; only emphasis, callouts and the material photo change.
const built=q('.lx-built');
if(built){
 const track=q('.lx-built__track',built),svg=q('.lx-cut',built),tabs=all('[data-built]',built),copy=all('[data-built-copy]',built);
 const photo=q('.lx-built__photo img',built),caption=q('.lx-built__photo figcaption',built),imgs=window.PB_HT?.__imgs||{};
 let current=-1;
 const setActive=i=>{if(i===current)return;current=i;
  tabs.forEach(t=>t.setAttribute('aria-selected',String(+t.dataset.built===i)));
  copy.forEach(c=>c.hidden=+c.dataset.builtCopy!==i);
  const active=copy[i];if(!active)return;
  const key=active.dataset.cutKey;built.dataset.layer=key;
  if(svg)all('[data-cut]',svg).forEach(g=>{g.classList.toggle('is-on',g.dataset.cut===key);g.classList.toggle('is-off',g.dataset.cut!==key);});
  const src=imgs[active.dataset.photo];const fig=photo&&photo.parentElement;
  if(fig)fig.hidden=!src;
  if(photo&&src&&photo.getAttribute('src')!==src){photo.src=src;photo.alt=active.dataset.caption||'';caption.textContent=active.dataset.caption||'';}
 };
 if(reduce){built.classList.add('is-static');setActive(0);}
 else tasks.push(vh=>{const r=track.getBoundingClientRect(),travel=track.offsetHeight-vh;
  const p=clamp(-r.top/Math.max(1,travel));setActive(Math.min(copy.length-1,Math.floor(p*copy.length*0.999)));});
 tabs.forEach(t=>t.addEventListener('click',()=>{const i=+t.dataset.built;
  if(reduce||built.classList.contains('is-static')){setActive(i);return;}
  const r=track.getBoundingClientRect(),travel=track.offsetHeight-innerHeight;
  goTo(scrollY+r.top+travel*((i+.5)/copy.length));}));
 
 function goTo(top){
  scrollTo({top,behavior:'smooth'});
  let last=scrollY,stillSince=performance.now(),live=true,timer=0;
  const give=()=>{live=false;off();};
  const off=()=>{clearTimeout(timer);['wheel','touchstart','keydown'].forEach(e=>removeEventListener(e,give));};
  ['wheel','touchstart','keydown'].forEach(e=>addEventListener(e,give,{once:true,passive:true}));
  
  const watch=()=>{
   if(!live)return;
   if(Math.abs(scrollY-top)<6){off();return;}
   if(Math.abs(scrollY-last)>2){last=scrollY;stillSince=performance.now();}
   if(performance.now()-stillSince>1100){scrollTo({top,behavior:'auto'});off();return;}
   timer=setTimeout(watch,120);
  };
  timer=setTimeout(watch,120);
 }
 setActive(0);
}

// ---- Seat map stays anchored: no scroll-driven movement of the shell itself.
//      (The seat pins, jet groups and body diagram carry the interaction.)

// ---- Collection imagery and cover teaser: gentle pointer tilt with specular sheen.
if(finePointer&&!reduce){
 const tiltables=all('[data-tilt], .selection-studio .pbht-model__media, .selection-studio [class*="model"] img');
 const seen=new Set();tiltables.forEach(el=>{const host=el.tagName==='IMG'?el.parentElement:el;if(seen.has(host))return;seen.add(host);host.classList.add('lx-tilt');
  host.addEventListener('pointermove',e=>{const r=host.getBoundingClientRect(),x=(e.clientX-r.left)/r.width-.5,y=(e.clientY-r.top)/r.height-.5;host.style.setProperty('--rx',(-y*7).toFixed(2)+'deg');host.style.setProperty('--ry',(x*9).toFixed(2)+'deg');host.style.setProperty('--sx',(x+.5)*100+'%');host.style.setProperty('--sy',(y+.5)*100+'%');host.classList.add('is-tilting');});
  host.addEventListener('pointerleave',()=>{host.classList.remove('is-tilting');host.style.setProperty('--rx','0deg');host.style.setProperty('--ry','0deg');});});
}

// ---- Cover teaser: real swatch photographs as a living mosaic on the cover lid.
const teaser=q('.lx-cover-teaser');
if(teaser&&window.PB_HT?.cover){const A=window.PB_HT.__imgs||{},cs=window.PB_HT.cover.colours;const wrap=q('.lx-cover-teaser__swatches',teaser),lid=q('.lx-mini-cover',teaser);const picks=[0,7,10,5,14,19];let k=0;
 picks.forEach(i=>{const c=cs[i],s=document.createElement('span');s.style.backgroundImage=`url("${A[c.file.replace('.webp','-t.webp')]||A[c.file]}")`;s.title=c.name;wrap.append(s);});
 const show=()=>{const c=cs[picks[k%picks.length]];lid.style.setProperty('--finish',`url("${A[c.file]}")`);all('span',wrap).forEach((s,j)=>s.classList.toggle('is-on',j===k%picks.length));k++;};
 show();if(!reduce){let timer;new IntersectionObserver(([e])=>{clearInterval(timer);if(e.isIntersecting)timer=setInterval(show,2600);}).observe(teaser);}
}

// ---- Evening: slow photographic push as it crosses the viewport.
const evening=q('.lx-evening__media img');
if(evening&&!reduce)tasks.push(vh=>{const r=evening.parentElement.getBoundingClientRect();if(r.bottom<0||r.top>vh)return;const p=clamp((vh-r.top)/(vh+r.height));evening.style.transform=`translate3d(0,${(p-.5)*-8}%,0) scale(${1.14-p*.08})`;});

// ---- Winter image settles in as the section arrives.
const winter=q('.lx-winter');if(winter){if(reduce)winter.classList.add('is-seen');else new IntersectionObserver(([e],o)=>{if(e.isIntersecting){winter.classList.add('is-seen');o.disconnect();}},{threshold:.2}).observe(winter);}

// ---- Header: quiet over the hero, solid once the page takes over.
const hero=q('.lx-hero');
if(hero){const head=q('.site-head'),dept=q('.department');tasks.push(()=>{const over=hero.getBoundingClientRect().bottom>80;document.body.classList.toggle('lx-over-hero',over);});}

schedule();
})();
